import { addTableHeader, breakWord, drawBody } from "../InvoiceGeneratorUtils";
import { IGeneratePDF_RESMI } from "../generateInvoice.type";

const PDF_RESMI = (data: IGeneratePDF_RESMI) => {
  const header = [
    {
      title: "NO",
      style: {
        width: 10,
      },
    },
    {
      title: "NAMA BARANG",
      style: {
        width: 150,
      },
    },
    {
      title: "SAT",
      style: {
        width: 20,
      },
    },
    {
      title: "HARGA",
      style: {
        width: 35,
      },
    },
    {
      title: "QTY",
      style: {
        width: 20,
      },
    },
    {
      title: "TOTAL",
    },
  ];

  // Data Table
  const dataTable: any[] = [];
  data.invoice.forEach((item, index) => {
    let temp: any[] = [];
    temp.push(index + 1); // No
    temp.push(item.name); // Nama Barang
    temp.push(item.unitType); // Satuan
    temp.push(item.price); // Harga
    temp.push(item.qty); // Qty
    temp.push(item.total); // Total
    dataTable.push(temp);
    temp = [];
  });

  // Minimum Rows
  // for (let i = dataTable.length; i < 5; i++) {
  //   let temp: any[] = [];
  //   temp.push(" ");
  //   dataTable.push(temp);
  // }

  const print = async (doc: any) => {
    // Variable
    const docWidth = doc.internal.pageSize.width;
    const docHeight = doc.internal.pageSize.height;
    const currentHeight = 15;
    const colorBlack = "#000000";
    const colorGray = "#4d4e53";
    const fieldTextSize = 10;
    const subLineHeight = 4;
    const tdWidth = (doc.getPageWidth() - 20) / header.length;
    const headerTextSize = 20;
    const labelTextSize = 12;
    const lineHeight = 6;

    const pdfConfig = {
      docWidth,
      docHeight,
      currentHeight,
      colorBlack,
      colorGray,
      fieldTextSize,
      subLineHeight,
      header,
      dataTable,
      tdWidth,
      headerTextSize,
      labelTextSize,
      lineHeight,
    };

    // Header Invoice
    // doc.addImage(data.logo, "PNG", 10, 10, 22, 22);
    doc.setFontSize(pdfConfig.headerTextSize);
    doc.setTextColor(pdfConfig.colorBlack);
    doc.text(10, currentHeight, `${data.companyName}`);
    doc.setFontSize(12);
    doc.text(
      pdfConfig.docWidth - 9,
      pdfConfig.currentHeight,
      `Tanggal : ${data.date} `,
      "right"
    );
    doc.setFontSize(12);
    pdfConfig.currentHeight += breakWord(
      `Customer: ${data?.customerName || ""}`,
      doc,
      pdfConfig.currentHeight + 7,
      pdfConfig.docWidth - 12
    );
    pdfConfig.currentHeight += breakWord(
      data?.customerPhone || "",
      doc,
      pdfConfig.currentHeight + 7 + 5,
      pdfConfig.docWidth - 12
    );
    pdfConfig.currentHeight += breakWord(
      data?.customerAddress || "",
      doc,
      pdfConfig.currentHeight + 7 + 5 + 5,
      pdfConfig.docWidth - 12
    );
    doc.setFontSize(pdfConfig.fieldTextSize);
    pdfConfig.currentHeight += 5;
    doc.text(10, pdfConfig.currentHeight, `${data.companyAddress}`);
    pdfConfig.currentHeight += 5;
    doc.text(10, pdfConfig.currentHeight, `${data.companyPhone}`);
    pdfConfig.currentHeight += 5;
    doc.text(10, pdfConfig.currentHeight, `${data.companyLocation}`);
    pdfConfig.currentHeight += 5;
    doc.setFontSize(pdfConfig.fieldTextSize);
    // doc.text(
    //   pdfConfig.docWidth - 10,
    //   pdfConfig.currentHeight + 2,
    //   `# ${data.invoiceNumber}`,
    //   "right"
    // );
    doc.setFontSize(12);
    doc.setTextColor(pdfConfig.colorBlack);
    doc.text(10, pdfConfig.currentHeight + 2, `INVOICE`);
    doc.setFontSize(pdfConfig.fieldTextSize);
    doc.setTextColor(pdfConfig.colorGray);
    pdfConfig.currentHeight += pdfConfig.subLineHeight;
    doc.line(
      10,
      pdfConfig.currentHeight,
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight
    );
    pdfConfig.currentHeight += 1;

    // Table Header
    addTableHeader({ doc: doc, config: pdfConfig });
    doc.line(
      10,
      pdfConfig.currentHeight,
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight
    );

    // Table Body
    doc.setFontSize(pdfConfig.fieldTextSize + 1);
    drawBody({ doc: doc, config: pdfConfig });
    doc.line(
      10,
      pdfConfig.currentHeight + 6,
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight + 6
    );

    // Footer Invoice Right Side
    // pdfConfig.currentHeight = pdfConfig.currentHeight - 44;

    //TOTAL
    pdfConfig.currentHeight += 12;
    doc.text(
      pdfConfig.docWidth / 1.2,
      pdfConfig.currentHeight,
      "TOTAL:",
      "right"
    );
    doc.text(
      pdfConfig.docWidth - 10,
      pdfConfig.currentHeight,
      `${data.total}`,
      "right"
    );

    // ========================================================
    // doc.setFontSize(11);
    // pdfConfig.currentHeight += 6;
    // doc.text(
    //   pdfConfig.docWidth - 8,
    //   pdfConfig.currentHeight,
    //   "TOTAL PACKING, NOTA, & TGL PACKING :",
    //   "right"
    // );
    // pdfConfig.currentHeight += 6;
    // doc.text(
    //   pdfConfig.docWidth - 8,
    //   pdfConfig.currentHeight,
    //   "......................................",
    //   "right"
    // );

    // Invoice Tanda Terima
    // doc.setFontSize(pdfConfig.fieldTextSize);
    // pdfConfig.currentHeight += 15;
    // doc.text(10, pdfConfig.currentHeight, "PENERIMA,");
    // doc.line(
    //   10,
    //   pdfConfig.currentHeight + 15,
    //   50,
    //   pdfConfig.currentHeight + 15
    // );
    // doc.text(
    //   pdfConfig.docWidth - 10,
    //   pdfConfig.currentHeight,
    //   "HORMAT KAMI,",
    //   "right"
    // );
    // doc.line(
    //   pdfConfig.docWidth - 10,
    //   pdfConfig.currentHeight + 15,
    //   pdfConfig.docWidth - 50,
    //   pdfConfig.currentHeight + 15
    // );
  };

  return { print };
};

export { PDF_RESMI };
